import React, {useState, useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {resetPassword} from '../../../../api/modules/auth'
import {Form} from 'react-bootstrap'
import {useLocation, Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useTranslation, initReactI18next} from 'react-i18next'
import swal from 'sweetalert'

export function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [token, setToken] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isMatch, setIsMatch] = useState(false)

  const [userMail, setUserMail] = useState('')

  const setReset = async () => {
    await resetPassword({
      email: userMail,
      token: token,
      password: newPassword,
      password_confirmation: confirmPassword,
    })
      .then((res) => {
        swal({
          icon: 'success',
          title: res.data.message,
        })
        // alert(res.data.message)
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            icon: 'error',
            title: error.response.data.message,
          })
          // alert(error.response.data.message)
        }
      })
  }

  const checkConfirm = (input: any) => {
    setConfirmPassword(input)
    if (newPassword == confirmPassword) {
      setIsMatch(true)
    } else {
      setIsMatch(false)
    }
  }

  const param = useLocation()

  useEffect(() => {
    const temp = param.search.split('=')
    const temp2 = temp[1]?.split('&')
    setToken(temp2[0])
    const temp3 = temp2[1]?.split('+')
    setUserMail(temp3[1])
  }, [])

  const {t} = useTranslation()

  return (
    <>
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        // style={{
        //   backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
        // }}
      >
        {/* begin::Content */}
        <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
          {/* begin::Logo */}
          <a href='#' className='mb-12'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-100px' />
          </a>
          {/* end::Logo */}
          {/* begin::Wrapper */}
          <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>
            <div className='form w-100'>
              <div className='text-center mb-10'>
                {/* begin::Title */}
                <h1 className='text-dark mb-3'>Reset Password</h1>
                {/* end::Title */}

                {/* begin::Link */}
                <div className='text-gray-400 fw-bold fs-4'>Enter your new password.</div>
                {/* end::Link */}
              </div>

              {/* begin::Title */}
              {hasErrors === true && (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>
                    Sorry, looks like there are some errors detected, please try again.
                  </div>
                </div>
              )}

              {hasErrors === false && (
                <div className='mb-10 bg-light-info p-8 rounded'>
                  <div className='text-info'>Sent password reset. Please check your email</div>
                </div>
              )}
              {/* end::Title */}

              {/* begin::Form group */}
              <div className='fv-row mb-10'>
                <Form.Control
                  type='password'
                  placeholder='New password'
                  autoComplete='off'
                  onChange={(e: any) => setNewPassword(e.target.value)}
                />
              </div>

              <div className='fv-row mb-10'>
                <span
                  className='text-danger'
                  hidden={isMatch && confirmPassword != '' ? false : true}
                >
                  Password is not match!
                </span>
                <Form.Control
                  type='password'
                  placeholder='Confirm Password'
                  autoComplete='off'
                  onChange={(e: any) => checkConfirm(e.target.value)}
                />
              </div>
              {/* end::Form group */}

              {/* begin::Form group */}
              <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                <button
                  onClick={() => setReset()}
                  id='kt_password_reset_submit'
                  className='btn btn-lg fw-bolder me-4 text-light'
                  style={{backgroundColor: '#274070'}}
                >
                  <span className='indicator-label'>{t('submit')}</span>
                  {loading && (
                    <span className='indicator-progress'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <Link to='/auth/login'>
                  <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-lg btn-secondary fw-bolder'
                  >
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Content */}
        {/* begin::Footer */}
        <div className='d-flex flex-center flex-column-auto p-10'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <a href='#' className='text-muted text-hover-primary px-2'>
              About
            </a>

            <a href='#' className='text-muted text-hover-primary px-2'>
              Contact
            </a>

            <a href='#' className='text-muted text-hover-primary px-2'>
              Contact Us
            </a>
          </div>
        </div>
        {/* end::Footer */}
      </div>
    </>
  )
}
